module.exports = __webpack_public_path__ + "static/media/compliance_not_data_icon.79142d80.svg";